import { useState } from "react";

const ExpandedCell = ({ text }) => {
    const [expanded, setExpanded] = useState(false);

    if (!text) return null;

    return (
        <div
            className="p-1 bg-gray-100 rounded-md text-xs"
            style={{
            whiteSpace: expanded ? "normal" : "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer",
            maxWidth: expanded ? "none" : 200,
            }}
            title={text}
            onClick={() => setExpanded(!expanded)}
        >
            {text}
            {!expanded && " ..."}
        </div>
    );
};

export default ExpandedCell;